import { Container, Typography } from '@mui/material';

export const Attribution = () => {
  return (
    <Container>
      <Typography
        margin={4}
        variant="body2"
        color="textSecondary"
        align="center"
      >
        © 2025 DeviceHub — All rights reserved
      </Typography>
    </Container>
  );
};

